import type { CartItem } from "../types/store";

export function hasSessionCheckoutParam(): boolean {
  const params = new URLSearchParams(globalThis.location.search);
  return Boolean(params.get("sessionId") || params.get("session_id"));
}

export function upsertCartItem(
  items: CartItem[],
  incoming: Omit<CartItem, "quantity">
): CartItem[] {
  const index = items.findIndex((item) => item.key === incoming.key);
  if (index === -1) {
    return [...items, { ...incoming, quantity: 1 }];
  }
  return items.map((item, i) =>
    i === index ? { ...item, quantity: item.quantity + 1 } : item
  );
}
